<div class="error-dialog">
  <div class="text-center warning-dialog">
    <img src="assets/img/warning-emoji.png" class="card-icon" alt="">
    <h6>{{data?.msg}}</h6>
    <p class="mt-3 my-2"></p>    
    <button *ngIf="data.noCloseButton" class="btn-link btn-block" type="button" (click)="closeErrorDialogInfo()">Close</button>
  </div>
</div>